import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {Commits as CommitsComponent} from './Commits'
import {pullRequestsCommitsRoute} from './commits-route'
import {pullRequestsLayoutRoute} from './layout-route'

export function CommitsEntrypointFuture() {
  const {
    data: {pullRequest, aliveChannel, repository},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  const {
    data: {metadata, commitGroups, timeOutMessage, truncated},
    dataUpdatedAt,
  } = useRouteQuery(pullRequestsCommitsRoute, 'mainQuery')

  return (
    <CommitsComponent
      aliveChannel={aliveChannel}
      aliveChannelThrottleTimeout={10_000}
      commitGroups={commitGroups}
      dataUpdatedAt={dataUpdatedAt}
      metadata={metadata}
      pullRequest={pullRequest}
      repository={repository}
      timeOutMessage={timeOutMessage}
      truncated={truncated}
    />
  )
}

try{ CommitsEntrypointFuture.displayName ||= 'CommitsEntrypointFuture' } catch {}